import { Link } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { t } = useLanguage();

  return (
    <footer data-testid="footer" className="bg-obsidian border-t border-white/5">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-24 py-28 md:py-36">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8">
          {/* Logo & Tagline */}
          <div className="md:col-span-5">
            <Link
              to="/"
              data-testid="footer-logo"
              className="font-playfair text-3xl md:text-4xl tracking-tight text-[#F5F5F0] block mb-8"
            >
              VELMONT <span className="text-gold">SOCIETY</span>
            </Link>
            <p className="text-[#A1A1AA] text-sm leading-relaxed max-w-sm font-manrope font-light mb-6">
              {t('footer.tagline')}
            </p>
            <p className="text-[#52525B] text-xs font-cormorant italic tracking-wide">
              {t('footer.motto')}
            </p>
          </div>

          {/* Navigation Links */}
          <div className="md:col-span-3">
            <h4 className="text-xs uppercase tracking-[0.2em] text-gold/80 mb-8 font-manrope font-medium">
              {t('footer.navigate')}
            </h4>
            <ul className="space-y-5">
              {[
                { path: '/experiences', labelKey: 'nav.experiences' },
                { path: '/cities', labelKey: 'nav.cities' },
                { path: '/about', labelKey: 'nav.about' },
                { path: '/contact', labelKey: 'nav.contact' }
              ].map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    data-testid={`footer-link-${link.path.replace('/', '')}`}
                    className="text-[#A1A1AA] hover:text-[#F5F5F0] transition-colors duration-300 text-sm font-manrope underline-hover"
                  >
                    {t(link.labelKey)}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Destinations */}
          <div className="md:col-span-2">
            <h4 className="text-xs uppercase tracking-[0.2em] text-gold/80 mb-8 font-manrope font-medium">
              {t('footer.destinations')}
            </h4>
            <ul className="space-y-5">
              <li>
                <span className="text-[#A1A1AA] text-sm font-manrope">{t('cities.sp')}</span>
              </li>
              <li>
                <span className="text-[#A1A1AA] text-sm font-manrope">{t('cities.rio')}</span>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div className="md:col-span-2">
            <h4 className="text-xs uppercase tracking-[0.2em] text-gold/80 mb-8 font-manrope font-medium">
              {t('footer.connect')}
            </h4>
            <Link
              to="/contact"
              data-testid="footer-contact-link"
              className="inline-block border border-gold text-gold px-6 py-3 text-xs uppercase tracking-[0.15em] font-bold hover:bg-gold hover:text-black transition-all duration-500"
            >
              {t('nav.contact')}
            </Link>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-24 pt-10 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-6">
          <p className="text-[#3F3F46] text-xs font-manrope">
            &copy; {currentYear} Velmont Society. {t('footer.rights')}
          </p>
          <p className="text-[#3F3F46] text-xs font-cormorant italic tracking-wide">
            {t('footer.invitation')}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
